export default function WeatherSchedulerSummaryCards({ status }) {
  const jobs = status?.jobs || [];

  const enabledCount = status?.jobsEnabled ?? jobs.filter((row) => row.enabled).length;
  const failingCount =
    status?.jobsFailing ?? jobs.filter((row) => (row.consecutiveFailures || 0) > 0).length;
  const lockedCount = jobs.filter((row) => row.lastStatus === "running").length;

  const lastRun = jobs
    .map((row) => row.lastRunAt)
    .filter(Boolean)
    .sort()
    .reverse()[0];

  const cards = [
    {
      label: "Scheduler",
      value: status?.schedulerEnabled ? status.schedulerMode || "enabled" : "disabled",
    },
    { label: "Jobs enabled", value: String(enabledCount) },
    { label: "Jobs failing", value: String(failingCount) },
    { label: "Locked / running", value: String(lockedCount) },
    {
      label: "Last run",
      value: lastRun ? new Date(lastRun).toLocaleString() : "—",
    },
  ];

  return (
    <div className="admin-dashboard__cards admin-dashboard__cards--compact">
      {cards.map((card) => (
        <div key={card.label} className="admin-dashboard__card">
          <div className="admin-dashboard__card-label">{card.label}</div>
          <div className="admin-dashboard__card-value">{card.value}</div>
        </div>
      ))}
    </div>
  );
}
